import { render, staticRenderFns } from "./MyOrdersView.vue?vue&type=template&id=26e8333e&"
import script from "./MyOrdersView.vue?vue&type=script&lang=js&"
export * from "./MyOrdersView.vue?vue&type=script&lang=js&"
import style0 from "./MyOrdersView.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
installComponents(component, {VBtn,VIcon,VLayout,VSkeletonLoader})
